import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IListQueryPaginationPayload } from '@app-store/slices/companies/list'

interface TaskAction extends Action {
    payload: IListQueryPaginationPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.sourceCategories.list

// This saga is for getting list of companies
function* listSagaTask({ payload }: TaskAction) {
    try {
        const params = {
            ...payload.pagination,
            necessaryProjectionArray: payload.necessaryProjectionArray,
            query: payload.query
        }

        const response = yield axios.get(`/companies/source-categories`, {
            params
        })
        if (response.success) {
            yield put(onSuccess({ ...response.result, gettingMainCategories: payload.gettingMainCategories || false }))
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* listSaga(): any {
    yield takeLatest<TaskAction>(onRequest, listSagaTask)
}

export default listSaga
